import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function StorySingleColumn({ section, data, theme }) {
  const anim = section.animation || {};
  const { title, paragraph, secondaryParagraph } = data;
  if (!paragraph && !secondaryParagraph) return null;

  return (
    <section className="px-5 py-20 sm:py-24" data-testid="story-section">
      <div className="max-w-sm mx-auto text-center">
        <AnimatedSection preset={anim.text || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-6"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            {title || 'With Love'}
          </p>
        </AnimatedSection>
        <AnimatedSection preset={anim.text || 'fade-up'} delay={0.1}>
          <p
            className="text-base sm:text-lg leading-relaxed"
            style={{ color: theme.textPrimary, opacity: 0.85, fontFamily: theme.bodyFont }}
          >
            {paragraph || ''}
          </p>
        </AnimatedSection>
        {secondaryParagraph && (
          <AnimatedSection preset={anim.text || 'fade-up'} delay={0.2}>
            <p
              className="text-sm leading-relaxed mt-4"
              style={{ color: theme.textSecondary, fontFamily: theme.bodyFont }}
            >
              {secondaryParagraph}
            </p>
          </AnimatedSection>
        )}
        <AnimatedSection preset="fade-in" delay={0.2}>
          <div className="mt-8 flex justify-center">
            <div className="w-16 h-px" style={{ background: theme.border }} />
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
